// 2026-09-19 FASE 2 FIXER Hero split (research 2026 Next.js code-split +
// LCP: el shell del Hero conserva el h1/p copy crítico para el LCP mientras
// el composer funcional vive en su propia isla `HeroComposer.tsx`; los
// helpers de handoff viven aquí como módulo puro sin dependencias).
// Handoff honesto con login (websearch 2026-09-13 AuthGear/login UX): el
// draft se guarda en localStorage antes de navegar a /chat — el gate lo
// restaura tras el signup/login sin pérdida. Contrato GET ?prompt&autoSend
// intacto (ver Hero.test.tsx).

export const HERO_PENDING_PROMPT_KEY = "vortixy:pending-prompt";

/** Guarda el draft (trim, tope 4000) para restaurarlo tras el login. No-op en SSR o sin storage. */
export function savePendingPrompt(draft: string): void {
  try {
    const trimmed = (draft ?? "").trim().slice(0, 4000);
    if (trimmed) window.localStorage.setItem(HERO_PENDING_PROMPT_KEY, trimmed);
  } catch {}
}
